import React, { useState, useEffect } from "react";
import style from "./DashboardStyle";
import { getSubscriptionSummary } from "../../Services/subscriptionService"; // Importa a nova função

export default function Dashboard() {
  const [summary, setSummary] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSummary = async () => {
      try {
        const data = await getSubscriptionSummary();
        setSummary(data);
      } catch (error) {
        console.error("Falha ao carregar os dados do dashboard", error);
      } finally {
        setLoading(false);
      }
    };

    fetchSummary();
  }, []);

  const formatCurrency = (value) => {
    if (typeof value !== 'number') return 'R$ 0,00';
    return value.toLocaleString("pt-BR", {
      style: "currency",
      currency: "BRL",
    });
  };

  const getStatusStyle = (status) => {
    // Status da API: 1: Pendente, 2: Ativo/Pago, 3: Bloqueado
    if (status === 1) return style.statusPending;
    if (status === 3) return style.statusRefunded; // Reutilizando o estilo de estornado para bloqueado
    return style.statusPaid;
  };

  const getStatusText = (status) => {
    if (status === 1) return "Pendente";
    if (status === 2) return "Ativo";
    if (status === 3) return "Bloqueado";
    return "Desconhecido";
  };

  if (loading) {
    return <div style={{ color: 'white', textAlign: 'center', padding: '50px', fontSize: '18px' }}>Carregando dados...</div>;
  }

  if (!summary) {
    return <div style={{ color: '#F87171', textAlign: 'center', padding: '50px', fontSize: '18px' }}>Não foi possível carregar os dados do dashboard.</div>;
  }

  return (
    <div style={style.dashboardContainer}>
      <header style={style.header}>
        <div>
          <h1 style={style.title}>Dashboard</h1>
          <p style={style.subtitle}>
            Bem-vindo! Aqui está o resumo da sua operação.
          </p>
        </div>
      </header>

      <div style={style.cardsContainer}>
        <div style={style.card}>
          <div style={style.cardIconWrapper}>👥</div>
          <h3 style={style.cardTitle}>Assinaturas Ativas</h3>
          <p style={style.cardValue}>{summary.activeSubscriptionsCount}</p>
        </div>
        <div style={style.card}>
          <div style={style.cardIconWrapper}>💲</div>
          <h3 style={style.cardTitle}>Valor em Assinaturas</h3>
          <p style={style.cardValue}>
            {formatCurrency(summary.totalValueActiveSubscriptions)}
          </p>
        </div>
        <div style={style.card}>
          <div style={style.cardIconWrapper}>⏳</div>
          <h3 style={style.cardTitle}>Pagamentos Pendentes</h3>
          <p style={style.cardValue}>{summary.pendingPaymentSubscriptionsCount}</p>
        </div>
        <div style={style.card}>
          <div style={style.cardIconWrapper}>🚫</div>
          <h3 style={style.cardTitle}>Assinaturas Bloqueadas</h3>
          <p style={style.cardValue}>{summary.blockedSubscriptionsCount}</p>
        </div>
      </div>

      <div style={style.tableContainer}>
        <h2 style={style.tableTitle}>Assinaturas com Pagamento Pendente</h2>
        <table style={style.table}>
          <thead>
            <tr style={style.tableHeadRow}>
              <th style={style.tableHeader}>Cliente</th>
              <th style={style.tableHeader}>Plano</th>
              <th style={style.tableHeader}>Status</th>
              <th style={{ ...style.tableHeader, textAlign: "right" }}>
                Valor
              </th>
            </tr>
          </thead>
          <tbody>
            {summary.pendingPaymentSubscriptions.length > 0 ? (
              summary.pendingPaymentSubscriptions.map((sub) => (
                <tr key={sub.subscription.id} style={style.tableRow}>
                  <td style={style.tableCell}>{sub.enterprise.name}</td>
                  <td style={style.tableCell}>{sub.subscriptionType.name}</td>
                  <td style={style.tableCell}>
                    <span
                      style={{
                        ...style.statusBadge,
                        ...getStatusStyle(sub.subscription.status),
                      }}
                    >
                      {getStatusText(sub.subscription.status)}
                    </span>
                  </td>
                  <td style={{ ...style.tableCell, ...style.valueCell }}>
                    {formatCurrency(sub.subscriptionType.value)}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="4" style={{ textAlign: 'center', padding: '20px', color: '#8B949E' }}>
                  Nenhuma assinatura pendente no momento.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
